import client from "~/graphql/client";
import {
  REGISTER_MODERATION_ACTIVITY,
  RegisterModerationActivity,
  RegisterModerationActivityVariables
} from "~/graphql/mutations/aliexpress/registerModerationActivity";

export default class ModerationActivityManager {
  public static async registerModerationActivity(
    action: string,
    optionId: string
  ): Promise<void> {
    const userSlug = localStorage.getItem("user_slug") || "unknown";
    this.updateLocalStorage(action);

    await client.mutate<
      RegisterModerationActivity,
      RegisterModerationActivityVariables
    >({
      mutation: REGISTER_MODERATION_ACTIVITY,
      variables: {
        input: {
          action,
          optionId,
          userSlug
        }
      }
    });
  }

  private static updateLocalStorage(action: string) {
    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const day = new Date().getDate();

    const monthKey = `${year}-${month}`;
    const dayKey = `${year}-${month}-${day}`;

    const initial = {
      delete: 0,
      delete_remoderation: 0,
      option_moderation_page: 0,
      skip: 0,
      submit: 0,
      submit_remoderation: 0
    };

    const moderationActivityRaw = localStorage.getItem("moderation_activity");
    const moderationActivityOld = moderationActivityRaw
      ? JSON.parse(moderationActivityRaw)
      : {
          [monthKey]: initial,
          [dayKey]: initial
        };

    const moderationActivity = {
      ...moderationActivityOld,
      [monthKey]: {
        ...(moderationActivityOld[monthKey] || initial),
        [action]: (moderationActivityOld[monthKey] || initial)[action] + 1
      },
      [dayKey]: {
        ...(moderationActivityOld[dayKey] || initial),
        [action]: (moderationActivityOld[dayKey] || initial)[action] + 1
      }
    };

    localStorage.setItem(
      "moderation_activity",
      JSON.stringify(moderationActivity)
    );
  }
}



// WEBPACK FOOTER //
// ./src/util/registerModerationActivity.ts